import { useParams } from 'react-router-dom'
import { Modal } from '@pepper/ui'

import AIDocMenu from 'components/CreateMenu/AIDocMenu'

type Props = {
  showCreateContentPopover: boolean
  setShowCreateContentPopover: (isOpen: boolean) => void
}

const CreateContentPopover = ({
  showCreateContentPopover,
  setShowCreateContentPopover,
}: Props) => {
  const { projectId } = useParams<{ projectId: string }>()

  return (
    <Modal
      size="sm"
      visible={showCreateContentPopover}
      onCancel={() => setShowCreateContentPopover(false)}
      footer={null}
      bodyStyle={{ padding: 0, width: '100%' }}
      closable={false}
    >
      <AIDocMenu
        onClose={() => setShowCreateContentPopover(false)}
        projectId={projectId}
      />
    </Modal>
  )
}

export default CreateContentPopover
